module.exports = __webpack_public_path__ + "assets/img/img-training-03.df667207.jpg";